import * as Sentry from '@sentry/browser';

import { ReservationAvailabilityResponse } from '@type-def_iqfu/public/ReservationAvailability';

const backendBasePath = process.env.NEXT_PUBLIC_DEV_BACKEND_URL;

export const useReservationAvailability = () => {
  const getReservationAvailability = async (companyId: number): Promise<ReservationAvailabilityResponse> => {
    const url = `${backendBasePath}/companies/${companyId}/visit_reservation_availabilities`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch visit reservation availabilities: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      Sentry.captureException(error);
      console.error('Error:', error);
      throw error;
    }
  };

  return {
    getReservationAvailability,
  };
};
